<template>
  <footer class="footer">
    <section class="content">
      <div class="company">
        <i class="gm99"></i>
        <p class="copyright">@Copyright 2021 www.gm99.com All Rights Reserved.優勢領航科技有限公司</p>
      </div>
      <div class="description">
        <i class="grade"></i>
        <div class="des">
          <p>本遊戲內含輕度暴力（打鬥、攻擊），戀愛交友。</p>
          <p>本遊戲為免費使用，遊戲內另提供購買虛擬遊戲幣、物品等付費服務。</p>
          <p>長時間進行遊戲，容易影響正常作息，宜適度休息及運動。</p>
        </div>
        <ul class="link">
          <li class="item"><a href="https://service.gm99.com/about/abouts.html" target="_blank">關於我們</a></li>
          <li class="item"><a href="https://service.gm99.com/about/termsofuse.html" target="_blank">服務條款</a></li>
          <li class="item"><a href="https://service.gm99.com/about/cooperation.html" target="_blank">合作提案</a></li>
          <li class="item"><a href="https://www.gm99.com/service" target="_blank">客服中心</a></li>
        </ul>
      </div>
    </section>
  </footer>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
  @import "@/assets/scss/footer.scss";
</style>
